import { __extends } from "tslib";
import { Event } from './Event';
import { notImplemented } from '@awayfl/swf-loader';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: MouseEvent
var MouseEvent = /** @class */ (function (_super) {
    __extends(MouseEvent, _super);
    function MouseEvent(type, bubbles, cancelable, localX, localY, relatedObject, ctrlKey, altKey, shiftKey, buttonDown, delta) {
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = false; }
        if (localX === void 0) { localX = undefined; }
        if (localY === void 0) { localY = undefined; }
        if (relatedObject === void 0) { relatedObject = null; }
        if (ctrlKey === void 0) { ctrlKey = false; }
        if (altKey === void 0) { altKey = false; }
        if (shiftKey === void 0) { shiftKey = false; }
        if (buttonDown === void 0) { buttonDown = false; }
        if (delta === void 0) { delta = 0; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._localX = localX;
        _this._localY = localY;
        _this._relatedObject = relatedObject;
        _this._ctrlKey = ctrlKey;
        _this._altKey = altKey;
        _this._shiftKey = shiftKey;
        _this._buttonDown = buttonDown;
        _this._delta = delta;
        return _this;
    }
    /**
   * AS3 mouse event names don't match DOM even names, so map them here.
   */
    MouseEvent.typeFromDOMType = function (name) {
        switch (name) {
            case 'click':
                return MouseEvent.CLICK;
            case 'dblclick':
                return MouseEvent.DOUBLE_CLICK;
            case 'mousedown':
                return MouseEvent.MOUSE_DOWN;
            case 'mouseout':
            case 'mouseover':
            case 'mousemove':
                return MouseEvent.MOUSE_MOVE;
            case 'mouseup':
                return MouseEvent.MOUSE_UP;
            default:
                notImplemented(name);
            // return MouseEvent.RELEASE_OUTSIDE;
            // return MouseEvent.MOUSE_WHEEL;
            // return MouseEvent.ROLL_OUT;
            // return MouseEvent.ROLL_OVER;
            // return MouseEvent.MIDDLE_CLICK;
            // return MouseEvent.MIDDLE_MOUSE_DOWN;
            // return MouseEvent.MIDDLE_MOUSE_UP;
            // return MouseEvent.RIGHT_CLICK;
            // return MouseEvent.RIGHT_MOUSE_DOWN;
            // return MouseEvent.RIGHT_MOUSE_UP;
            // return MouseEvent.CONTEXT_MENU;
        }
    };
    /* added to clone events from away to as3web. */
    MouseEvent.prototype.fillFromAway = function (awayEvent) {
        //console.log("cloneFromAway not implemented yet in flash/MouseEvent");
        this.adaptee = awayEvent;
        this.target = awayEvent.target.adapter || this.sec.flash.display.DisplayObject.axClass._activeStage;
        this.currentTarget = awayEvent.currentTarget.adapter || this.sec.flash.display.DisplayObject.axClass._activeStage;
        this.delta = awayEvent.delta;
        this.ctrlKey = awayEvent.ctrlKey;
        this.shiftKey = awayEvent.shiftKey;
        this.buttonDown = Boolean(awayEvent.buttons & 1 /* MouseButtons.PRIMARY_BUTTON */);
        //this._stageX = awayEvent.screenX;
        //this._stageY = awayEvent.screenY;
        //todo: translate more stuff from awayjs to as3
        //result.screenX = this.screenX;
        //result.screenY = this.screenY;
        /*
        result.view = awayEvent.view;
        result.entity = awayEvent.entity;
        result.renderable = awayEvent.renderable;
        result.material = awayEvent.material;
        result.uv = awayEvent.uv;
        result.position = awayEvent.position;
        result.normal = awayEvent.normal;
        result.elementIndex = awayEvent.elementIndex;
*/
        //result._iParentEvent = awayEvent;
        //result._iAllowedToPropagate = awayEvent._iAllowedToPropagate;
    };
    Object.defineProperty(MouseEvent.prototype, "localX", {
        get: function () {
            return (this._localX / 20) | 0;
        },
        set: function (value) {
            this._localX = (value * 20) | 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "localY", {
        get: function () {
            return (this._localY / 20) | 0;
        },
        set: function (value) {
            this._localY = (value * 20) | 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "stageX", {
        get: function () {
            if (isNaN(this.localX + this.localY)) {
                return Number.NaN;
            }
            return this.target.stage.mouseX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "stageY", {
        get: function () {
            if (isNaN(this.localX + this.localY)) {
                return Number.NaN;
            }
            return this.target.stage.mouseY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "movementX", {
        get: function () {
            return this._movementX || 0;
        },
        set: function (value) {
            this._movementX = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "movementY", {
        get: function () {
            return this._movementY || 0;
        },
        set: function (value) {
            this._movementY = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "delta", {
        get: function () {
            return this._delta;
        },
        set: function (value) {
            this._delta = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "ctrlKey", {
        get: function () {
            return this._ctrlKey;
        },
        set: function (value) {
            this._ctrlKey = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "altKey", {
        get: function () {
            return this._altKey;
        },
        set: function (value) {
            this._altKey = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "shiftKey", {
        get: function () {
            return this._shiftKey;
        },
        set: function (value) {
            this._shiftKey = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "buttonDown", {
        get: function () {
            return this._buttonDown;
        },
        set: function (value) {
            this._buttonDown = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "relatedObject", {
        get: function () {
            return this._relatedObject;
        },
        set: function (value) {
            this._relatedObject = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MouseEvent.prototype, "isRelatedObjectInaccessible", {
        get: function () {
            return this._isRelatedObjectInaccessible;
        },
        set: function (value) {
            this._isRelatedObjectInaccessible = value;
        },
        enumerable: false,
        configurable: true
    });
    MouseEvent.prototype.updateAfterEvent = function () {
        this.sec.player.requestRender();
    };
    MouseEvent.prototype.clone = function () {
        return new MouseEvent(this.type, this.bubbles, this.cancelable, this.localX, this.localY, this.relatedObject, this.ctrlKey, this.altKey, this.shiftKey, this.buttonDown, this.delta);
    };
    MouseEvent.prototype.toString = function () {
        return this.formatToString('MouseEvent', 'type', 'bubbles', 'cancelable', 'eventPhase', 'localX', 'localY', 'relatedObject', 'ctrlKey', 'altKey', 'shiftKey', 'buttonDown', 'delta');
    };
    MouseEvent.classInitializer = null;
    MouseEvent.classSymbols = null;
    MouseEvent.instanceSymbols = null;
    // JS -> AS Bindings
    MouseEvent.CLICK = 'click';
    MouseEvent.DOUBLE_CLICK = 'doubleClick';
    MouseEvent.MOUSE_DOWN = 'mouseDown';
    MouseEvent.MOUSE_MOVE = 'mouseMove';
    MouseEvent.MOUSE_OUT = 'mouseOut';
    MouseEvent.MOUSE_OVER = 'mouseOver';
    MouseEvent.MOUSE_UP = 'mouseUp';
    MouseEvent.RELEASE_OUTSIDE = 'releaseOutside';
    MouseEvent.MOUSE_WHEEL = 'mouseWheel';
    MouseEvent.ROLL_OUT = 'rollOut';
    MouseEvent.ROLL_OVER = 'rollOver';
    MouseEvent.MIDDLE_CLICK = 'middleClick';
    MouseEvent.MIDDLE_MOUSE_DOWN = 'middleMouseDown';
    MouseEvent.MIDDLE_MOUSE_UP = 'middleMouseUp';
    MouseEvent.RIGHT_CLICK = 'rightClick';
    MouseEvent.RIGHT_MOUSE_DOWN = 'rightMouseDown';
    MouseEvent.RIGHT_MOUSE_UP = 'rightMouseUp';
    MouseEvent.CONTEXT_MENU = 'contextMenu';
    return MouseEvent;
}(Event));
export { MouseEvent };
